module.exports = __webpack_public_path__ + "img/6.8b472942.png";